/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class CreditCardDtoModel extends JSONable {
  cardNumber: string | undefined = undefined;
  cardName: string | undefined = undefined;
  expirationDate: string | undefined = undefined;
  defaultCard: boolean | undefined = undefined;

  constructor() {
    super();
    this.cardNumber = undefined;
    this.cardName = undefined;
    this.expirationDate = undefined;
    this.defaultCard = false;
  }

}
